// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as TailwindMerge from "tailwind-merge";
import IcoCarSvg from "./solid/ico-car.svg";
import IcoDotSvg from "./solid/ico-dot.svg";
import IcoPinSvg from "./solid/ico-pin.svg";
import IcoChatSvg from "./solid/ico-chat.svg";
import IcoInfoSvg from "./solid/ico-info.svg";
import IcoLockSvg from "./solid/ico-lock.svg";
import IcoMemoSvg from "./solid/ico-memo.svg";
import IcoMoonSvg from "./solid/ico-moon.svg";
import IcoPlusSvg from "./solid/ico-plus.svg";
import IcoSendSvg from "./solid/ico-send.svg";
import IcoStarSvg from "./solid/ico-star.svg";
import IcoCheckSvg from "./solid/ico-check.svg";
import IcoClockSvg from "./solid/ico-clock.svg";
import IcoMinusSvg from "./solid/ico-minus.svg";
import IcoPhoneSvg from "./solid/ico-phone.svg";
import IcoCameraSvg from "./solid/ico-camera.svg";
import IcoDeleteSvg from "./solid/ico-delete.svg";
import IcoRepairSvg from "./solid/ico-repair.svg";
import IcoHeadsetSvg from "./solid/ico-headset.svg";
import IcoWarningSvg from "./solid/ico-warning.svg";
import IcoCheckboxSvg from "./solid/ico-checkbox.svg";
import IcoFacilitySvg from "./solid/ico-facility.svg";
import IcoLocationSvg from "./solid/ico-location.svg";
import IcoInsuranceSvg from "./solid/ico-insurance.svg";
import IcoThumbsUpSvg from "./solid/ico-thumbs-up.svg";
import IcoUninsuredSvg from "./solid/ico-uninsured.svg";
import IcoCircleWonSvg from "./solid/ico-circle-won.svg";
import IcoSuggestionSvg from "./solid/ico-suggestion.svg";
import IcoExclamationSvg from "./solid/ico-exclamation.svg";
import IcoCircleCloseSvg from "./solid/ico-circle-close.svg";
import IcoCheckCalendarSvg from "./solid/ico-check-calendar.svg";
import IcoCircleQuestionSvg from "./solid/ico-circle-question.svg";

var icoCamera = IcoCameraSvg;

var icoCircleClose = IcoCircleCloseSvg;

var icoInfo = IcoInfoSvg;

var icoPlus = IcoPlusSvg;

var icoCar = IcoCarSvg;

var icoClock = IcoClockSvg;

var icoInsurance = IcoInsuranceSvg;

var icoSuggestion = IcoSuggestionSvg;

var icoCheck = IcoCheckSvg;

var icoExclamation = IcoExclamationSvg;

var icoLocation = IcoLocationSvg;

var icoUninsured = IcoUninsuredSvg;

var icoSend = IcoSendSvg;

var icoPhone = IcoPhoneSvg;

var icoChat = IcoChatSvg;

var icoMemo = IcoMemoSvg;

var icoRepair = IcoRepairSvg;

var icoFacility = IcoFacilitySvg;

var icoThumbsUp = IcoThumbsUpSvg;

var icoCheckCalendar = IcoCheckCalendarSvg;

var icoLock = IcoLockSvg;

var icoDelete = IcoDeleteSvg;

var icoMoon = IcoMoonSvg;

var icoPin = IcoPinSvg;

var icoDot = IcoDotSvg;

var icoMinus = IcoMinusSvg;

var icoStar = IcoStarSvg;

var icoCircleQuestion = IcoCircleQuestionSvg;

var icoCircleWon = IcoCircleWonSvg;

var icoHeadset = IcoHeadsetSvg;

var icoCheckbox = IcoCheckboxSvg;

var icoWarning = IcoWarningSvg;

function convert(t) {
  if (t === "ico-camera") {
    return icoCamera;
  } else if (t === "ico-warning") {
    return icoWarning;
  } else if (t === "ico-circle-close") {
    return icoCircleClose;
  } else if (t === "ico-thumbs-up") {
    return icoThumbsUp;
  } else if (t === "ico-exclamation") {
    return icoExclamation;
  } else if (t === "ico-circle-won") {
    return icoCircleWon;
  } else if (t === "ico-circle-question") {
    return icoCircleQuestion;
  } else if (t === "ico-suggestion") {
    return icoSuggestion;
  } else if (t === "ico-phone") {
    return icoPhone;
  } else if (t === "ico-check") {
    return icoCheck;
  } else if (t === "ico-checkbox") {
    return icoCheckbox;
  } else if (t === "ico-clock") {
    return icoClock;
  } else if (t === "ico-delete") {
    return icoDelete;
  } else if (t === "ico-repair") {
    return icoRepair;
  } else if (t === "ico-check-calendar") {
    return icoCheckCalendar;
  } else if (t === "ico-chat") {
    return icoChat;
  } else if (t === "ico-info") {
    return icoInfo;
  } else if (t === "ico-lock") {
    return icoLock;
  } else if (t === "ico-memo") {
    return icoMemo;
  } else if (t === "ico-moon") {
    return icoMoon;
  } else if (t === "ico-plus") {
    return icoPlus;
  } else if (t === "ico-headset") {
    return icoHeadset;
  } else if (t === "ico-facility") {
    return icoFacility;
  } else if (t === "ico-send") {
    return icoSend;
  } else if (t === "ico-star") {
    return icoStar;
  } else if (t === "ico-location") {
    return icoLocation;
  } else if (t === "ico-insurance") {
    return icoInsurance;
  } else if (t === "ico-car") {
    return icoCar;
  } else if (t === "ico-dot") {
    return icoDot;
  } else if (t === "ico-pin") {
    return icoPin;
  } else if (t === "ico-minus") {
    return icoMinus;
  } else {
    return icoUninsured;
  }
}

function CDS_Icon_Solid(props) {
  var __className = props.className;
  var className = __className !== undefined ? __className : "";
  return React.createElement(convert(props.name), {
              className: TailwindMerge.twMerge("w-6 h-6 text-blue-gray-900", className),
              style: props.style,
              height: "24",
              width: "24"
            });
}

var make = CDS_Icon_Solid;

export {
  icoCamera ,
  icoCircleClose ,
  icoInfo ,
  icoPlus ,
  icoCar ,
  icoClock ,
  icoInsurance ,
  icoSuggestion ,
  icoCheck ,
  icoExclamation ,
  icoLocation ,
  icoUninsured ,
  icoSend ,
  icoPhone ,
  icoChat ,
  icoMemo ,
  icoRepair ,
  icoFacility ,
  icoThumbsUp ,
  icoCheckCalendar ,
  icoLock ,
  icoDelete ,
  icoMoon ,
  icoPin ,
  icoDot ,
  icoMinus ,
  icoStar ,
  icoCircleQuestion ,
  icoCircleWon ,
  icoHeadset ,
  icoCheckbox ,
  icoWarning ,
  convert ,
  make ,
}
/* icoCamera Not a pure module */
